module.exports = __webpack_public_path__ + "static/media/Colette Ray King Headboard - 180 cm_White.bf2a9552.png";